import React, { useEffect } from 'react';
import { isAndroidCapacitor } from '../../utils/platformUtils';
import './DesktopGridAd.css';

/**
 * Fixed 728×90 leaderboard for desktop browse grids (full-width row).
 * Create a matching Display ad unit in AdSense and pass its slot id.
 * Hidden on Capacitor (AdMob) and below 720px (phone uses MobileGridAd).
 */
export default function DesktopGridAd({ slot }) {
    const isNative = isAndroidCapacitor?.() === true;

    useEffect(() => {
        if (isNative || !slot) return;

        try {
            if (typeof window !== 'undefined') {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (e) {
            console.error('AdSense grid push error:', e);
        }
    }, [isNative, slot]);

    if (isNative || !slot) return null;

    return (
        <div className="msv-desktop-grid-ad" aria-label="Advertisement">
            <div className="msv-desktop-grid-ad-inner">
                <ins
                    className="adsbygoogle"
                    style={{ display: 'inline-block', width: '728px', height: '90px' }}
                    data-ad-client="ca-pub-1511890644353474"
                    data-ad-slot={slot}
                />
            </div>
        </div>
    );
}
